import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet, ViewStyle} from 'react-native';

export const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.13,
  shadowRadius: 2.62,
  elevation: 4,
};

export default (props: ITheme) =>
  StyleSheet.create({
    metaDataClassContainerStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      paddingHorizontal: 16,
      marginBottom: 10,
    },
    lessonTextStyle: {
      color: props.colors.primaryTextColor,
      ...props.typography.interMedium,
      fontSize: 17,
    },
    textStyle: {
      color: props.colors.primaryTextColor,
      fontSize: 17,
      marginVertical: 6,
      ...props.typography.interRegular,
    },
    fontSize15: {
      fontSize: 15,
    },
    closePopUpButtonStyle: {
      justifyContent: 'center',
      alignItems: 'center',
      width: 35,
      height: 35,
      borderRadius: 50,
      backgroundColor: props.colors.lightPurple,
    },
    closePopUpImage: {
      width: 15,
      height: 15,
    },
    defaultButtonStyle: {
      alignItems: 'center',
      flexDirection: 'row',
      height: 53,
      paddingLeft: 18,
    },
    cancelButtonStyle: {
      borderBottomWidth: 1,
      borderBottomColor: props.colors.cornflowerBlueWithOpacity(0.13),
    },
    deleteButtonStyle: {},
    defaultImageStyle: {
      marginRight: 14,
    },
    cancelImageStyle: {
      width: 10,
      height: 10,
    },
    deleteImageStyle: {
      width: 12,
      height: 14,
      tintColor: props.colors.red,
    },
    defaultLabelButtonStyle: {
      fontSize: 18,
      ...props.typography.interRegular,
    },
    cancelLabelButtonStyle: {
      color: props.colors.primaryTextColor,
    },
    deleteLabelButtonStyle: {
      color: props.colors.red,
    },
    ...Platform.select({
      default: {
        backDropStyle: {
          justifyContent: 'flex-end',
          paddingBottom: 42,
        },
        contentContainerStyle: {
          justifyContent: 'center',
          alignItems: 'center',
          width: 343,
          height: 237,
          backgroundColor: props.colors.white,
          borderRadius: 20,
        },
        buttonContainerStyle: {
          width: '100%',
          height: 106,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderTopColor: props.colors.cornflowerBlueWithOpacity(0.13),
          borderBottomColor: props.colors.cornflowerBlueWithOpacity(0.13),
        },
      },
      web: {
        backDropStyle: {
          backgroundColor: 'transparent',
        },
        contentContainerStyle: {
          position: 'absolute',
          top: 300,
          left: 25,
          justifyContent: 'center',
          alignItems: 'center',
          width: 343,
          height: 237,
          backgroundColor: props.colors.dirtyWhite,
          borderRadius: 8,
          ...shadow,
        },
        buttonContainerStyle: {
          width: '100%',
          height: 106,
        },
      },
    }),
  });
